module.exports = __webpack_public_path__ + "img/nav-design-halfsize.4eac402.webp";